import { isEmpty } from "lodash";

export const getRegionValueByKey = (key: string) => {
  const regionValueMap: Record<string, string> = {
    aggregated: 'Aggregated',
    market: 'By Country',
    region: 'By Region',
  };
  return (list: any[]) => {
    list.push(['Region Setting', regionValueMap[key]]);
    return list;
  };
};
export const setTimeSettingsByDateMethod = (key: string) => {
  const timValueMap: Record<string, string> = {
    aggregated: 'Aggregated',
    separate: 'By Time',
  };
  return (list: any[]) => {
    list.push(['Time Settings', timValueMap[key]]);
    return list;
  };
};

const getMarket = (regionOptions: any) => {
  const codeObject: any = {};
  if (regionOptions) {
    for (const item of regionOptions) {
      const countrySet = item?.country_set || [];
      for (const t of countrySet) {
        codeObject[t.country_code] = t.area_name_en;
      }
    }
  }
  return codeObject;
};
export const getPlatformByKey = (params: any) => {
  let listValue = 'global';
  const { markets, regionOptions } = params || {};
  const regionObject: any = getMarket(regionOptions);
  if (markets?.length && !markets.includes('global')) {
    const marketList = [];
    for (const item of markets) {
      marketList.push(regionObject[item]);
    }
    listValue = marketList.join(',');
  }
  return (list: any[]) => {
    list.push(['Region/countries', listValue]);
    return list;
  };
};
export const getFileFormatByKey = (key: any) => {
  const fileFormatValueMap: Record<string, string> = {
    '1': 'CSV',
    '0': 'Excel',
  };
  return (list: any[]) => {
    list.push(['File Format', fileFormatValueMap[key]]);
    return list;
  };
};
export const setTimingByDateMethod = (params: any) => {
  let str = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { start_release_time, end_release_time, start_date, end_date, granularity } = params || {};
  if (start_release_time && end_release_time) {
    const granularityObject: Record<string, string> = {
      daily: 'D',
      weekly: 'W',
      monthly: 'M',
    };
    const gItem = granularityObject[granularity];
    str = `Release ${gItem}${start_release_time}-${gItem}${end_release_time}`;
  } else {
    str = `${start_date}-${end_date}`;
  }
  return (list: any[]) => {
    list.push(['Time Setting', str]);
    return list;
  };
};

export const setStartAndEndByDateMethod = (params: any) => {
  let start = '';
  let end = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { start_date, end_date } = params || {};
  start = start_date;
  end = end_date;
  return (list: any[]) => {
    list.push(
      ...[
        ['Date Start', start],
        ['Date End', end],
      ],
    );
    return list;
  };
};

export const setMetricsByList = (metrics: Record<string, any>, maps: Record<string, string>) => {
  if(isEmpty(metrics)) return [];
  const val = Object.values(metrics).flat();
  const innerList: any[] = [];
  val?.forEach((item: any, idx: number) => {
    innerList.push([idx === 0 ? 'Metrics' : '', maps[item]]);
  });
  return (list: any[]) => {
    list.push(...innerList);
    return list;
  };
};
